import { UPDATE_QUANTITY_INPUT, HIGHLIGHT_QUANTITY_INPUT, RESET_QUANTITY_INPUT } from "../constants";

export const resetQuantityInput = (data) => ({
    type: RESET_QUANTITY_INPUT,
    payload: data
});

export const updateQuantityInput = (data) => ({
    type: UPDATE_QUANTITY_INPUT,
    payload: data
});

export const highlightQuantityInput = (data) => ({
    type: HIGHLIGHT_QUANTITY_INPUT,
    payload: data
});

highlightQuantityInput